module.exports = __webpack_public_path__ + "static/media/thought.4a4b3edd.jpg";